module.exports = __webpack_public_path__ + "static/media/table_sort_icon.a43f5a28.svg";